/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the FboApiConfiguration configuration object with a given root URL.
 */
export function provideFboApiConfiguration(rootUrl: string) {
  var config = new FboApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: FboApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class FboApiConfiguration {
  rootUrl: string = '/';
}

